module.exports = __webpack_public_path__ + "img/JGlogo.9a7b4cf8.png";